import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  PenalChargeTable,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { message } from "antd";
import { useForm } from "react-hook-form";
import { Card } from "reactstrap";
import { useDebounce } from "../../../hooks/useDebounceSearch";

export const PenalChargeManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    product: 0,
    minDaysElapsed: 0,
    maxDaysElapsed: 0,
    penalRate: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [PenalRate, setPenalRate] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [details, setDetails] = useState({});
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getPenalRate();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: parseFloat(e.target.value) });
  };

  const resetForm = () => {
    setFormData({
      product: 0,
      minDaysElapsed: 0,
      maxDaysElapsed: 0,
      penalRate: 0,
    });
  };

  const [products, setProducts] = useState();

  const getAllProducts = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trproduct`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      const filteredProducts = resultData.filter((data) => data.status === "ACTIVE");
      if (resultData) {
        setProducts(filteredProducts);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getPenalRate = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trpenal-charge?search=${search}`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setPenalRate(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };

  const addPenalRate = async (obj) => {
    try {
      setIsLoadBtn(true);
      setIsLoading(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/trpenal-charge`, obj, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      if (data) {
        getPenalRate();
        setIsLoadBtn(false);
        setIsLoading(false);
        message.success({
          content: "Charge Created",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { data };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const deleteProductCat = async () => {
    try {
      setIsLoading(true);
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/auth/admin/trpenal-charge/${details}`, {
        headers: authHeader(),
      });
      const data = await response.data;
      if (data) {
        getPenalRate();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ delete: false });
        resetForm();
      }
      return { data };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      getPenalRate();
      setModal({ delete: false });
      resetForm();
      return { message };
    }
  };

  const editPenalRate = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/trpenal-charge/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getPenalRate();
        setIsLoadBtn(false);
        setIsLoading(false);
        message.success({
          content: "Edited Successfully",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const onDeleteClick = (items) => {
    setModal({ delete: true });
    setDetails(items.id);
  };

  const onFormSubmit = () => {
    addPenalRate(formData);
    // resetForm();
    setModal({ add: false });
  };

  const onEditSubmit = () => {
    editPenalRate(formData);
    // resetForm();
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      product: items.product.id,
      minDaysElapsed: items.minDaysElapsed,
      maxDaysElapsed: items.maxDaysElapsed,
      penalRate: items.penalRate,
      id: items.id,
    });
    setDetails(items);
    setEditedId(items.id);
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = PenalRate?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getPenalRate();
    getAllProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const productOptions =
    products?.map((prod) => ({
      label: prod.productName,
      value: prod.id,
    })) ?? [];

  return (
    <React.Fragment>
      <Head title="Penal Charge Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Penal Charge</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Penal Charge..."
                    />
                  </div>
                  <Button color="primary" onClick={() => setModal({ add: true })}>
                    <Icon name="plus"></Icon>
                    <span>Add Charge</span>
                  </Button>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <PenalChargeTable
                PenalRate={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
                handleDel={onDeleteClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {PenalRate && PenalRate.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={PenalRate?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Penal Charge found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Penal Charge</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Product Name</label>
                      <RSelect
                        options={productOptions}
                        onChange={(e) => setFormData({ ...formData, product: parseInt(e.value) })}
                      />
                      {errors.product && <span className="invalid">{errors.product.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Minimum % Days Elapse</label>
                      <input
                        type="number"
                        step="any"
                        name="minDaysElapsed"
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.minDaysElapsed && <span className="invalid">{errors.minDaysElapsed.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Maximum % Days Elapse</label>
                      <input
                        type="number"
                        step="any"
                        name="maxDaysElapsed"
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.maxDaysElapsed && <span className="invalid">{errors.maxDaysElapsed.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Penal rate</label>
                      <input
                        type="number"
                        step="any"
                        name="penalRate"
                        // value={formData.penalRate}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.penalRate && <span className="invalid">{errors.penalRate.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Rate</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Product Name</label>
                      <RSelect
                        options={productOptions}
                        value={productOptions.filter(({ value }) => value === formData.product)[0]}
                        onChange={(e) => setFormData({ ...formData, product: parseInt(e.value) })}
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Minimum % Days Elapse</label>
                      <input
                        type="number"
                        step="any"
                        name="minDaysElapsed"
                        defaultValue={formData.minDaysElapsed}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Maximum % Days Elapse</label>
                      <input
                        type="number"
                        step="any"
                        name="maxDaysElapsed"
                        defaultValue={formData.maxDaysElapsed}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Penal rate</label>
                      <input
                        type="number"
                        step="any"
                        name="penalRate"
                        defaultValue={formData.penalRate}
                        placeholder="0.00"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Update
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.delete}
          toggle={() => setModal({ delete: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Delete Penal Charge</h5>
              <div className="mt-4">
                <Button onClick={deleteProductCat} color="danger" size="lg">
                  Delete
                </Button>
                <Button onClick={onFormCancel} className="ml-2" color="secondary" size="lg">
                  Cancel
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
